import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom"
import Navbar from "./innerHader";
import Sidebar from "./sideBar";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import BaseUrl from "../BaseUrl"
import Ideal from '../Assets/Ideal.png'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CheckoutForm from './CheckoutForm';
import { ProfileProvider } from '../context/ProfileContext';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe("pk_live_51MtVVsAq8B2KTw3f7ewjMwyy6SbMVasMe3Oa07tj5mdKgZR3jHltCO8UJm0uQrC5NDYV0QRHG4hYUZUUW7vzbI7W00a6luawhF");
var apiCall = true;
const HOC = (Wcomponenet) => {
    return function Component() {
        const [hamb, setHamb] = useState(false);
        const [amount, setAmount] = useState(15);
        const [showModal, setShowModal] = useState(false);
        const [showInput, setShowInput] = useState(false);
        const [showIdealForm, setShowIdealForm] = useState(false);
        const [showPayButton, setShowPayButton] = useState(true);
        const [crossButton, setCrossButton] = useState();
        const [success, setSuccess] = useState(false);
        const [orderID, setOrderID] = useState(false);
        // const [apiCall, setApiCall] = useState(true);
        const navigate = useNavigate()
        const [searchParams] = useSearchParams()

        useEffect(() => {

            var popUpClose = localStorage.getItem('popUpClose');

            var profile = JSON.parse(localStorage.getItem('profile'))
            striprPayment();
            // console.log("profile",profile,profile.subcription_popup )
            if (popUpClose !== 'true' && profile && Number(profile.subcription_popup) === 0) {
                setShowModal(true)
                setCrossButton(false)
            }
            if (popUpClose !== 'true' && profile && Number(profile.subcription_popup) === 1) {
                setShowModal(true)
                setCrossButton(true)
            }
            if (profile && Number(profile.subcription_popup) === 2) {
                setShowModal(false)
                setCrossButton(false)
            }

            if (success) {
                // alert("Payment successful!!");
                console.log('Order successful . Your order id is--', orderID);
            }
        // Keep the original popup/payment side-effect timing unchanged.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [success]);

        const popupClose = () => {
            localStorage.setItem("popUpClose", "true");
            setShowModal(false)
        }

        // creates a paypal order
        const createOrder = (data, actions) => {
            return actions.order.create({
                intent: "CAPTURE",
                purchase_units: [
                    {
                        description: "Serendipity",
                        amount: {
                            currency_code: "EUR",
                            value: amount,
                        },
                    },
                ],
            }).then((orderID) => {
                setOrderID(orderID);
                return orderID;
            });
        };

        const striprPayment = () => {
            var payment_intent = searchParams.get("payment_intent")
            var payment_intent_client_secret = searchParams.get("payment_intent_client_secret")
            var redirect_status = searchParams.get("redirect_status")
            console.log("popUpClose", apiCall, payment_intent, payment_intent_client_secret, redirect_status)
            if (apiCall === true && redirect_status === "succeeded") {
                apiCall = false;
                var token = localStorage.getItem("authorization")
                var auth = {
                    headers: {
                        authorization: `bearer ${token}`,
                    }
                };
                const url = BaseUrl() + "api/user/paypalPayment"
                const data = {
                    "amount": amount,
                    "paymentId": payment_intent,
                    "clientSecret": payment_intent_client_secret,
                    "reason": "",
                    "paymentstatus": "1",
                    "paymentMethod": "stripe",
                    "paymentType": Number(amount) === 15 ? "default" : "custom"
                }

                try {
                    axios.post(url, data, auth).then((response) => {
                        console.log(response)
                        if (response.status === 200) {
                            var profile = JSON.parse(localStorage.getItem('profile'))
                            profile.subcription_popup = 2;
                            localStorage.setItem("profile", JSON.stringify(profile));
                            popupClose();
                            navigate("/home");
                        }
                        else {
                            console.log(response.data.message);
                        }
                    });
                } catch (error) {
                }
            }
        }

        // check Approval
        const onApprove = (data, actions) => {
            return actions.order.capture().then(async (details) => {
                // const { payer } = details;
                console.log("details", details.purchase_units[0].payments.captures[0].id)
                setSuccess(true);

                const token = localStorage.getItem("authorization")
                var auth = {
                    headers: {
                        authorization: `bearer ${token}`,
                    }
                };
                const url = BaseUrl() + "api/user/paypalPayment"
                const data = {
                    "amount": amount,
                    "paymentId": details.purchase_units[0].payments.captures[0].id,
                    "reason": "",
                    "paymentstatus": "1",
                    "paymentType": Number(amount) === 15 ? "default" : "custom"
                }

                try {
                    const response = await axios.post(url, data, auth);
                    if (response.status === 200) {
                        var profile = JSON.parse(localStorage.getItem('profile'))
                        profile.subcription_popup = 2;
                        localStorage.setItem("profile", JSON.stringify(profile));
                        popupClose();
                    }
                    else {
                        console.log(response.data.message);
                    }
                } catch (error) {
                }

            });
        };

        return (
            <ProfileProvider>
            <>

                {showModal ? (
                    <>
                        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto px-4 py-6 outline-none focus:outline-none">
                            <div className="relative w-full max-w-md animate-[bsi-modal-pop_220ms_ease-out] overflow-hidden rounded-[1.75rem] border border-sky-100 bg-gradient-to-br from-white via-white to-sky-50 p-5 shadow-2xl shadow-slate-950/25 ring-1 ring-white/80 sm:p-6">
                                <div className="pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full bg-sky-200/60 blur-3xl" />
                                <div className="pointer-events-none absolute -bottom-16 left-6 h-28 w-28 rounded-full bg-blue-200/40 blur-3xl" />
                                {crossButton ? (
                                    <button
                                        type="button"
                                        className="absolute right-4 top-4 z-10 rounded-full bg-white/80 px-3 py-1 text-xs font-bold text-sky-700 shadow-sm ring-1 ring-sky-100 transition hover:-translate-y-0.5 hover:bg-sky-50"
                                        onClick={() => popupClose()}
                                    >
                                        Skip
                                    </button>
                                ) : null}
                                <div className="relative">
                                    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-blue-700 text-lg font-extrabold text-white shadow-lg shadow-sky-500/25">
                                        €
                                    </div>
                                    <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-sky-600">Subscription</p>
                                    <h5 className="mt-1 text-2xl font-extrabold tracking-tight text-slate-950">Unlock your full experience</h5>
                                    <p className="mt-2 text-sm font-medium leading-6 text-slate-600">Continue with the default amount or choose a custom payment.</p>
                                    <p className="mt-4 text-4xl font-extrabold tracking-tight text-slate-950">€{amount}</p>

                                    {!showInput && showPayButton && !showIdealForm && (
                                        <div className="mt-5 grid gap-3">
                                            <button onClick={e => setShowPayButton(false)} className="rounded-2xl bg-gradient-to-r from-sky-500 to-blue-700 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-700/25 focus:outline-none focus:ring-4 focus:ring-sky-100">Pay Now</button>
                                            <div className="relative flex items-center justify-center py-1">
                                                <hr className="w-full border-slate-200" />
                                                <span className="absolute bg-gradient-to-br from-white to-sky-50 px-3 text-xs font-bold uppercase tracking-[0.18em] text-slate-400">or</span>
                                            </div>
                                            <button onClick={e => {
                                                setShowInput(true)
                                            }} className="rounded-2xl border border-sky-200 bg-white px-5 py-3 text-sm font-bold text-sky-700 shadow-sm transition hover:-translate-y-0.5 hover:bg-sky-50 hover:shadow-md focus:outline-none focus:ring-4 focus:ring-sky-100">Pay a custom amount</button>
                                        </div>
                                    )}

                                    <button
                                        type="button"
                                        className="mt-4 text-sm font-bold text-slate-500 transition hover:text-sky-700"
                                        onClick={() => popupClose()}
                                    >
                                        Skip Payment
                                    </button>

                                    {showInput ? (
                                        <div className="mt-4 grid gap-3">
                                            <input
                                                type="text"
                                                value={amount}
                                                placeholder="15"
                                                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100"
                                                onChange={e => { console.log(e.target.value); setAmount(e.target.value) }}
                                            />
                                            <button onClick={e => { setShowPayButton(false); setShowInput(false) }} className="rounded-2xl bg-gradient-to-r from-sky-500 to-blue-700 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-700/25 focus:outline-none focus:ring-4 focus:ring-sky-100">Pay Now</button>
                                        </div>
                                    ) : null}

                                    <PayPalScriptProvider options={{ "currency": "EUR", "client-id": "AazXOEoLXlWy0SG5wHyDJ7Zm69FiSzU-m1cNbY0KbLlCkcirbSV-PjFSbq-4R8z5K0A8QHUPZvxQMx_G" }}>
                                        {!showPayButton ? (
                                            <div className="mt-4">
                                                <PayPalButtons
                                                    style={{ layout: "vertical" }}
                                                    createOrder={createOrder}
                                                    onApprove={onApprove}
                                                    fundingSource="paypal"
                                                />
                                            </div>
                                        ) : null}
                                    </PayPalScriptProvider>

                                    {!showPayButton ? (
                                        <div className="mt-4 grid gap-3">
                                            <div className="relative flex items-center justify-center py-1">
                                                <hr className="w-full border-slate-200" />
                                                <span className="absolute bg-gradient-to-br from-white to-sky-50 px-3 text-xs font-bold uppercase tracking-[0.18em] text-slate-400">or</span>
                                            </div>
                                            <button type="button" className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[#2557D6] px-5 py-3 text-sm font-bold text-white shadow-lg shadow-blue-600/20 transition hover:-translate-y-0.5 hover:bg-[#2557D6]/90 focus:outline-none focus:ring-4 focus:ring-blue-100"
                                                onClick={e => { setShowIdealForm(true); setShowPayButton(true) }}>
                                                <img src={Ideal} className="h-7 w-auto" alt="" />
                                                Pay with iDEAL
                                            </button>
                                        </div>
                                    ) : null}

                                    {showIdealForm ? (
                                        <div className="mt-4">
                                            <Elements stripe={stripePromise}>
                                                <CheckoutForm amount={amount} />
                                            </Elements>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="fixed inset-0 z-40 bg-slate-950/45 backdrop-blur-sm"></div>
                    </>
                ) : null}
                <section className="min-h-screen overflow-x-hidden bg-gradient-to-br from-slate-50 via-sky-50/70 to-blue-50 text-slate-900 md:flex">
                    <div className="hidden w-64 shrink-0 md:block">
                        <Sidebar
                            onClick={() => {
                                setHamb(true);
                            }}
                        />
                    </div>
                    {/* Components & Navbar */}
                    <div className="relative z-20 flex min-h-screen w-full flex-col transition-all duration-200">
                        <Navbar hamb={hamb} setHamb={setHamb} />
                        <div className="wcomp relative z-20 w-full flex-1 px-3 pb-6 pt-3 text-current sm:px-5 lg:px-6">
                            <Wcomponenet />
                        </div>
                    </div>
                </section>
            </>
            </ProfileProvider>
        );
    };
};

export default HOC;
